import { useReducedMotion } from 'framer-motion';
import React from 'react';
import { ReactComponent as LapturaCar } from '../../assets/brand/laptura-car.svg';
import { cn } from '../../lib/utils';

const CAR_W = 22;
const CAR_H = 5.8;

// Closed L-circuit: down the stem, around the foot, along the base, and
// back — the same silhouette as the brand mark. The car follows this path
// with offset-rotate: auto so it stays tangent through the hairpin.
export const TRACK_D =
  'M 16 6 L 16 70 C 16 88 30 96 50 96 L 80 96 C 84 96 84 78 80 78 L 54 78 C 40 78 38 74 38 66 L 38 6 C 38 2 16 2 16 6 Z';

/**
 * Loading indicator: the Laptura car lapping a thin L-shaped circuit.
 *
 * Size comes from the caller (`h-8 w-8`, `h-32 w-32`, ...); everything
 * inside scales off that box.
 */
export function CarSpinner({ className }) {
  const still = useReducedMotion();

  return (
    <div
      className={cn('relative shrink-0', className)}
      role="status"
      aria-label="Loading"
    >
      <svg viewBox="0 0 100 100" className="absolute inset-0 overflow-visible text-lap-hairline" aria-hidden>
        <path d={TRACK_D} fill="currentColor" opacity="0.14" stroke="none" />
        <path
          d={TRACK_D}
          fill="none"
          stroke="currentColor"
          strokeWidth="6.5"
          strokeLinejoin="round"
          strokeLinecap="round"
          opacity="0.55"
        />
        <path
          d={TRACK_D}
          fill="none"
          stroke="currentColor"
          strokeWidth="4.5"
          strokeLinejoin="round"
          strokeLinecap="round"
          opacity="0.25"
        />
        <path
          data-testid="carspinner-line"
          d={TRACK_D}
          fill="none"
          stroke="currentColor"
          strokeWidth="0.7"
          strokeDasharray="2.6 2"
          strokeLinejoin="round"
          strokeLinecap="round"
          opacity="0.9"
        />
        <g
          data-testid="carspinner-orbit"
          data-moving={still ? 'false' : 'true'}
          className={cn('text-lap-accent-bright', !still && 'animate-car-lap motion-reduce:animate-none')}
          style={
            still
              ? { transform: 'translate(50px, 96px)' }
              : { offsetPath: `path('${TRACK_D}')`, offsetRotate: 'auto' }
          }
        >
          <g transform={`translate(${-CAR_W / 2} ${-CAR_H / 2})`}>
            <LapturaCar width={CAR_W} height={CAR_H} />
          </g>
        </g>
      </svg>
    </div>
  );
}
